import React from 'react';
import { CTAButton } from './CTAButton';
import { PRICE } from './salesData';
import { AUDIENCE_IMAGE_URL } from '../utils/headMeta';
export function FinalCta() {
  return <section className="bg-white pb-24 pt-12 sm:pb-16 sm:pt-16" data-id="element-58" data-mp="19ez19c0t961n">
      <div className="mx-auto max-w-4xl px-5" data-id="element-59" data-mp="19gifkx2wp70s">
        <div className="overflow-hidden rounded-[2rem] bg-cream" data-id="element-60" data-mp="15dly59p3rgyf">
          <img src={AUDIENCE_IMAGE_URL} alt="Manos acomodando brownies y alfajores en una caja de postres en una cocina luminosa" loading="lazy" decoding="async" width={1000} height={1250} className="h-[180px] w-full object-cover sm:h-[260px]" data-id="element-61" data-mp="15fgialsjv51g" />

          <div className="px-6 py-8 text-center sm:px-10 sm:py-10" data-id="element-62" data-mp="1o3brdsd7vuo8">
            <h2 className="mx-auto max-w-[22ch] font-display text-[1.55rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[30ch] sm:text-[2.2rem]" data-id="element-63" data-mp="1o67pphsz8ld7">
              El objetivo no es que termines de leer.{' '}
              <span className="text-gold" data-id="element-64" data-mp="n64elx7608q5">Es que tengas algo para ofrecer.</span>
            </h2>

            <p className="mx-auto mt-3.5 max-w-[44ch] font-sans text-[0.9rem] leading-relaxed text-taupe sm:text-[0.98rem]" data-id="element-65" data-mp="s45wiesuu201">
              Elegí tus primeras recetas, calculá tus números, armá tu propuesta y empezá a mostrarla.
            </p>

            <p className="mt-6 font-display text-[1.1rem] font-extrabold uppercase leading-none tracking-tight text-charcoal" data-id="element-66" data-mp="1246i67e74u7e">
              Postres que Venden™
            </p>
            <p className="mt-2 font-sans text-[0.95rem] font-semibold text-charcoal" data-id="element-67" data-mp="1b28nv08vkb10">
              <span className="mr-2 font-medium text-taupe" style={{
              textDecoration: 'line-through'
            }} data-id="element-68" data-mp="1fvb8givoca52">
                {PRICE.previous}
              </span>
              {PRICE.current} ARS · pago único
            </p>

            <div className="mt-5 flex justify-center" data-id="element-69" data-mp="1pu0riezb40mw">
              <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-70" data-mp="1ttrnqy7lr8yt" />
            </div>

            <p className="mt-3 font-sans text-[0.74rem] font-medium text-taupe" data-id="element-71" data-mp="3quow0r7donna">
              Acceso digital inmediato · Pago seguro
            </p>
          </div>
        </div>
      </div>
    </section>;
}